import { render, staticRenderFns } from "./PersonasEdit.vue?vue&type=template&id=f02ffa94&scoped=true&"
import script from "./PersonasEdit.vue?vue&type=script&lang=js&"
export * from "./PersonasEdit.vue?vue&type=script&lang=js&"
import style0 from "./PersonasEdit.vue?vue&type=style&index=0&id=f02ffa94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02ffa94",
  null
  
)

export default component.exports